function markLargeImages() {
  const images = document.querySelectorAll('.article-template__content img');
  const captionArticle = document.querySelector('[data-image-captions]');
  const captions = captionArticle ? captionArticle.dataset.imageCaptions : null;

  images.forEach(image => {
    image.classList.remove('rte__large-image', 'is-hidden');
    if (image.complete) {
      addClassIfNecessary(image);
    } else {
      image.addEventListener('load', () => addClassIfNecessary(image), { once: true });
      image.addEventListener(
        'error',
        () => {
          image.classList.add('is-hidden');
          image.closest('figure')?.classList.add('is-hidden');
        },
        { once: true }
      );
    }
  });

  function addClassIfNecessary(image) {
    if (!image.naturalWidth) {
      image.classList.add('is-hidden');
      image.closest('figure')?.classList.add('is-hidden');
      return;
    }

    const parentWidth = image.parentElement.offsetWidth;
    const hasCustomCaption = image.closest('.iag-inset, .iag-pair, .iag-section-img');

    if (hasCustomCaption) {
      image.parentElement.removeAttribute('data-image-caption');
    } else if (captions === 'all' && image.alt) {
      image.parentElement.setAttribute('data-image-caption', image.alt);
    }

    if (image.naturalWidth > parentWidth) {
      image.classList.add('rte__large-image');

      if (!hasCustomCaption && captions === 'large' && image.alt) {
        image.parentElement.setAttribute('data-image-caption', image.alt);
      }
    }
  }
}

markLargeImages();
window.addEventListener('resizeend', markLargeImages);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', markLargeImages);
  document.addEventListener('shopify:block:select', markLargeImages);
}
